import * as React from "react";
import { Table, Container } from "react-bootstrap";
import { useLoaderData } from "react-router-dom";

export async function loader() {
  const networkInfo = await fetch("https://smeshi-api.com/network/info").then(
    (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return response.json();
    }
  );
  return { networkInfo };
}

export default function Network() {
  const { networkInfo } = useLoaderData();

  const displayNetworkInfo = () => {
    if (networkInfo) {
      return (
        <Container>
            <Table striped bordered hover variant="dark" size="sm">
            <tbody>
                <tr>
                <th>Epoch</th>
                <td>{networkInfo.epoch}</td>
                </tr>
                <tr>
                <td>Current Layer</td>
                <td>{networkInfo.layer}</td>
                </tr>
                <tr>
                <td>Epoch Subsidy</td>
                <td>{(networkInfo.epochSubsidy/1000000000).toFixed(2)} SMH</td>
                </tr>
                <tr>
                <td>Circulating Supply</td>
                <td>{(networkInfo.circulatingSupply/1000000000).toFixed(2)} SMH</td>
                </tr>
                <tr>
                <td>Price</td>
                <td>${(networkInfo.price).toFixed(2)}</td>
                </tr>
                <tr>
                <td>Market Cap</td>
                <td>${(networkInfo.marketCap/1000000000000000).toFixed(2)} Million</td>
                </tr>
                <tr>
                <td>Total Accounts</td>
                <td>{networkInfo.totalAccounts}</td>
                </tr>
                <tr>
                <td>Active Smeshers</td>
                <td>{networkInfo.totalActiveSmeshers}</td>
                </tr>
            </tbody>
            </Table>
        </Container>
      )
    } else {
      return <h1>Loading</h1>;
    }
  };

  return <>{displayNetworkInfo()}</>;
}
